// Header slider

/*const $headerProducts = $('.page-header__slider');
if($headerProducts.length) {
    $headerProducts.each(function(index, el) {
        const headerProducts = new HeaderSlider($(el));
    });
}*/
var $timer = null;

$( document ).ready(function() {
    var $sliderCounter = $('.page-header__slider .page-header__slider-slide:first').attr('data-attribute-number');
    $('.page-header__slider-total .current-slide').text($sliderCounter);

    function moveSlides() {
        //var $sliderCounter = $('.page-header__slider .page-header__slider-slide:first').attr('data-attribute-number');
        var $gallery = $('.page-header__slider');
        var $firstImg = $('.page-header__slider .page-header__slider-slide:first');
        var $nextImg = $firstImg.next();
        var $number = $nextImg.attr('data-attribute-number');
        var $counter = $('.page-header__slider-total .current-slide');
        $firstImg.appendTo($gallery)/*.animate({
            opacity: 1
        }, 300, function(){
        }).animate({
            opacity: 0
        }, 300, function(){
        })*/;
        $counter.text($number);
        /*$nextImg.animate({
            opacity: 0
        }, 300, function(){
        }).animate({
            opacity: 1
        }, 300, function(){
        });*/
    };

    $timer = setInterval( function(){
        moveSlides()
    }, 5000);

    $('.page-header__slider-total a').click(function(e) {
        e.preventDefault();
        console.log('next!');
        moveSlides();
        clearInterval($timer);
        $timer = setInterval(function(){
            moveSlides()
        }, 5000);
    });

});
